import axios from 'axios';

export const authService = {

  /** Collections */

  getCollectionsService: (params) => axios.get(`/carriers`, { auth: true, params: { ...params } }),

  getCollectionHistoryService: (params) => axios.get(`/collections`, { auth: true, params: { ...params } }),

  collectReserveService: (carrierId, params) => axios.patch(`/loads/collectReserve/carrier/${carrierId}`, params, { auth: true }),

  collectLoadService: (carrierId, params) => axios.patch(`/loads/collectDept/carrier/${carrierId}`, params, { auth: true }),

  /** End */
};